import { render, staticRenderFns } from "./customerNSupport.vue?vue&type=template&id=7e437366"
import script from "./customerNSupport.vue?vue&type=script&lang=js"
export * from "./customerNSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports